export default "__VITE_ASSET__BZ1Ww8AB__"